module.exports = __webpack_public_path__ + "static/media/img_landing02.479e1f8f.png";